import SchoolIcon from '@mui/icons-material/School';
import SettingsIcon from '@mui/icons-material/Settings';
import PeopleIcon from '@mui/icons-material/People';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Groups3Icon from '@mui/icons-material/Groups3';
import AppRegistrationTwoToneIcon from '@mui/icons-material/AppRegistrationTwoTone';
import PaymentsTwoToneIcon from '@mui/icons-material/PaymentsTwoTone';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssessmentIcon from '@mui/icons-material/Assessment';

// Import your custom image
//import CustomIconImage from '/virtual-event.png'; // Adjust the path as per your folder structure

const CustomIcon = () => (
  <img src='/virtual-event.png' alt="Custom Icon" style={{ width: '30px', height: '30px' }} />
);

const AttendanceIcon = () => (
  <img src='/immigration.png' alt="Custom Icon" style={{ width: '30px', height: '30px' }} />
);

const PaymentsIcon = () => (
  <img src='/cashless-payment.png' alt="Custom Icon" style={{ width: '30px', height: '30px' }} />
);

const QRIcon = () => (
  <img src='/scanner.png' alt="Custom Icon" style={{ width: '30px', height: '30px' }} />
);

const icons = { DashboardIcon, SettingsIcon, PeopleIcon, CalendarMonthIcon, SchoolIcon, Groups3Icon, AppRegistrationTwoToneIcon, PaymentsTwoToneIcon, AssignmentIcon, SettingsIcon, AssessmentIcon, CustomIcon, AttendanceIcon, PaymentsIcon, QRIcon };

const utilities = {
  id: 'utilities',
  //title: 'Utilities',
  type: 'group',
  children: [
    
    {
        id: 'default',
        title: 'Dashboard',
        type: 'item',
        url: '/studentdashboard',
        icon: icons.DashboardIcon,
        breadcrumbs: false
      },
      {
        id: 'profile',
        title: 'My Profile',
        type: 'item',
        url: '/myprofile',
        icon: icons.SettingsIcon,
        breadcrumbs: false
      },

    {
      id: 'demos',
      title: 'My Demos',
      type: 'item',
      url: '/mydemos',
        icon: icons.SchoolIcon,
      breadcrumbs: false
    },

    {
      id: 'classes',
      title: 'Enrolled Classes',
      type: 'item',
      url: '/enrolledclasses',
      icon: icons.CustomIcon,
      breadcrumbs: false
    },
    
      
      {
        id: 'attendance',
        title: 'My Attendance',
        type: 'item',
        url: '/viewattendance',
        icon: icons.AttendanceIcon,
        breadcrumbs: false,
      },
      {
        id: 'payments',
        title: 'My Payments',
        type: 'item',
        url: '/mypayments',
          icon: icons.PaymentsIcon,
        breadcrumbs: false
      },
      {
        id: 'qrcode',
        title: 'My Profile QRCode',
        type: 'item',
        url: '/myqrcode',
        icon: icons.QRIcon,
        breadcrumbs: false
      },
     /* {
        id: 'tests',
        title: 'My Tests',
        type: 'item',
        url: '/my-tests',
          icon: icons.AssignmentIcon,
        breadcrumbs: false
      },*/
    
  ]
};

export default utilities;